
<template>
  <div >
    <el-row class="info-list">
     <el-col :span="12" class="info-item" v-for="(item,index) in dataList" :key="index">
       <div class="content flx-justify-between " style="margin-right: 30px;">
         <div class="title">
          <img :src="item.img" alt="">
          {{item.title}}
        </div>
    
       </div>
      </el-col>

     <!-- 更多 .info-item -->
    </el-row>
  </div>
</template>
<script>


/**
 * Index-1 component
 */
export default {
  name:"KYC",
  components: {
  },
  data(){
    return {
        dataList:[
          {
            title:"公司营业执照彩色扫描件",
            img:this.$ossUrl+'icons/platform/platformIcon1.png',
          },
          {
            title:"公司首要联系人和受益人的身份证件",
            img:this.$ossUrl+'icons/platform/platformIcon2.png'
          },
          {
            title:"首要联系人和受益人的个人费用账单",
            img:this.$ossUrl+'icons/platform/platformIcon1.png',
          },
          {
            title:"补充材料",
            img:this.$ossUrl+'icons/platform/platformIcon2.png'
          },
          {
            title:"公司章程",
            img:this.$ossUrl+'icons/platform/platformIcon1.png',
          },
          {
            title:"银行账户所有人证明",
            img:this.$ossUrl+'icons/platform/platformIcon2.png'
          },
          {
            title:"授权函（如首要联系人非公司法人或者受益人时提供）",
            img:this.$ossUrl+'icons/platform/platformIcon1.png',
          }
        ]
    }
  },
  methods: {
   
  }
};
</script>
<style src="./componentsIndex.css" scoped></style>